import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { untilDestroyed } from '@ngneat/until-destroy';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { EventsService } from 'src/app/services/events.service';
import { SharedService } from 'src/app/services/shared.service';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { Location } from '@angular/common';
import { LocationHttpService } from 'src/app/http/location-http.service';

@Component({
    selector: 'app-location-edit',
    templateUrl: './location-edit.component.html',
    styles: [],
})
export class LocationEditComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        private locationHttpService: LocationHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private activatedRoute: ActivatedRoute
    ) {}

    editLocationForm = this.fb.group(
        {
            locationId: [null],
            locationName: [null, Validators.required],
            branchId: [null, Validators.required],
            cost: [null, Validators.required],
            isPublished: [false],
        },
        { updateOn: 'submit' }
    );

    locationModel: any;

    branches: any[] = [];

    formBusy: boolean;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.locationModel = data.data[0];
            this.branches = data.data[1];
            this.patchForm(data.data[0]);
        });
    }

    patchForm(item: any) {
        this.editLocationForm.patchValue(item);
    }

    onSubmit() {
        this.editLocationForm.markAsTouched();
        if (this.editLocationForm.valid) {
            this.formBusy = true;
            this.locationHttpService.editLocation(this.editLocationForm.value).subscribe(
                (result) => {
                    this.router.navigateByUrl('location-list', {
                        state: { hasState: true, type: 'success', message: 'Location Edited successfully' },
                    });
                },
                (error) => {
                    this.formBusy = false;
                    this.editLocationForm.setErrors({ exists: true });
                }
            );
        }
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.locationHttpService.deleteLocation(item.locationId).subscribe(() => {
            this.router.navigateByUrl('location-list', {
                state: { hasState: true, type: 'success', message: 'Location Deleted successfully' },
            });
        });
    }
}
